/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpinsights_Period_Pastfiveyears4Inputs */

const en_coinvestments_lpinsights_period_pastfiveyears4 = /** @type {(inputs: Coinvestments_Lpinsights_Period_Pastfiveyears4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past 5 years`)
};

/**
* | output |
* | --- |
* | "Past 5 years" |
*
* @param {Coinvestments_Lpinsights_Period_Pastfiveyears4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpinsights_period_pastfiveyears4 = /** @type {((inputs?: Coinvestments_Lpinsights_Period_Pastfiveyears4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpinsights_Period_Pastfiveyears4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpinsights_period_pastfiveyears4(inputs)
});
export { coinvestments_lpinsights_period_pastfiveyears4 as "coInvestments_lpInsights_period_pastFiveYears" }